<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动信息</span>
        <el-button type="primary" plain class="title-btn" @click="back()">返回</el-button>
      </div>
      <div style="width: 600px">
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          label-width="100px"
        >
          <el-form-item label="活动名称" prop="activityName">
            <el-input
              v-model="ruleForm.activityName"
              disabled
            />
          </el-form-item>
          <el-form-item label="活动时间" prop="activityTime">
            <el-date-picker
              v-model="ruleForm.activityTime"
              type="daterange"
              range-separator="至"
              disabled
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="活动说明" prop="activityExplain">
            <el-input
              v-model="ruleForm.activityExplain"
              type="textarea"
              :rows="4"
              disabled
            />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动配置</span>
      </div>
      <div style="width: 600px">
        <el-form
          ref="configForm"
          :model="configForm"
          label-width="100px"
        >
          <el-form-item label="组团规则" prop="activityReason">
            <el-input
              v-model="configForm.activityReason"
              type="textarea"
              :rows="4"
              disabled
            />
          </el-form-item>
          <el-form-item label="活动文案" prop="activityCopywriting">
            <img
              v-if="configForm.activityCopywriting"
              :src="
                this.action + '?objectName=' + configForm.activityCopywriting
              "
              class="avatar"
            >
            <span v-else class="imgborder">
              <i class="el-icon-plus avatar-uploader-icon" />
            </span>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">成团条件</span>
      </div>
      <div style="width: 600px">
        <el-form
          ref="configForm2"
          :model="configForm2"
          label-width="100px"
        >
          <el-form-item label="成团人数" prop="activityGroup">
            <el-input
              v-model="configForm2.activityGroup"
              disabled
            />
          </el-form-item>
          <el-form-item label="消费维度" prop="consumptionDimension">
            <el-radio-group v-model="configForm2.consumptionDimension" disabled>
              <el-radio label="2">金额</el-radio>
              <el-radio label="1">电量</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="奖励标准" prop="amount">
            <div
              v-if="configForm2.consumptionDimension === '1'"
              class="d-flex amount"
            >
              <div class="mr-10">满</div>
              <el-input
                v-model="configForm2.amount"
                type="number"
                disabled
              />
              <div class="ml-10">度</div>
            </div>
            <div
              v-if="configForm2.consumptionDimension === '2'"
              class="d-flex amount"
            >
              <div class="mr-10">满</div>
              <el-input
                v-model="configForm2.amount"
                type="number"
                disabled
              />
              <div class="ml-10">元</div>
            </div>
          </el-form-item>
          <el-form-item label="活动电站" prop="stationType">
            <el-radio-group v-model="configForm2.stationType" disabled>
              <el-radio
                v-for="(item, index) in activitystationType"
                :key="index"
                :label="item.id"
              >{{ item.label }}
              </el-radio>
            </el-radio-group>
            <!-- 选择运营商 -->
            <div v-show="configForm2.stationType === '2'" class="border">
              <el-tree
                ref="treeOperator"
                :data="operatorTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :default-checked-keys="configForm2.operator"
              />
            </div>
            <!-- 选择电站 -->
            <div v-show="configForm2.stationType === '3'" class="border">
              <el-tree
                ref="treeStation"
                :data="stationTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :default-checked-keys="configForm2.station"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动奖励</span>
      </div>
      <div style="width: 550px">
        <div>团长奖励</div>
        <el-form
          ref="rewardForm"
          :model="rewardForm"
          label-width="100px"
        >
          <template v-for="(row, index) in rewardForm.coupons">
            <el-form-item
              :key="index"
              :label="'优惠券' + numberfilter(index + 1)"
              prop="activityReward"
            >
              <div class="d-flex">
                <el-select
                  v-model="row.couponId"
                  filterable
                  style="width: 200px"
                  disabled
                >
                  <el-option
                    v-for="item in allCoupon"
                    :key="item.couponId"
                    :label="item.couponName"
                    :value="item.couponId"
                  />
                </el-select>
                <el-input
                  v-model="row.count"
                  type="number"
                  class="ml-20"
                  style="width: 100px"
                  disabled
                />
                <div class="ml-20">张</div>
              </div>
              <div class="d-flex currentStock">
                当前库存：{{ queryCouponStock(row.couponId) }}
              </div>
            </el-form-item>
          </template>
        </el-form>
        <div>团员奖励</div>
        <el-form
          ref="rewardForm2"
          :model="rewardForm2"
          label-width="100px"
        >
          <template v-for="(row, index) in rewardForm2.coupons">
            <el-form-item
              :key="index"
              :label="'优惠券' + numberfilter(index + 1)"
              prop="activityReward"
            >
              <div class="d-flex">
                <el-select
                  v-model="row.couponId"
                  filterable
                  style="width: 200px"
                  disabled
                >
                  <el-option
                    v-for="item in allCoupon"
                    :key="item.couponId"
                    :label="item.couponName"
                    :value="item.couponId"
                  />
                </el-select>
                <el-input
                  v-model="row.count"
                  type="number"
                  class="ml-20"
                  style="width: 100px"
                  disabled
                />
                <div class="ml-20">张</div>
              </div>
              <div class="d-flex currentStock">
                当前库存：{{ queryCouponStock(row.couponId) }}
              </div>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">可参与用户</span>
      </div>
      <div style="width: 600px">
        <el-form
          ref="partakeForm"
          :model="partakeForm"
          label-width="100px"
        >
          <el-form-item label="可参与用户" prop="userType">
            <el-radio-group v-model="partakeForm.userType" disabled>
              <el-radio
                v-for="(item, index) in userTypeItem"
                :key="index"
                :label="item.id"
              >{{ item.label }}</el-radio>
            </el-radio-group>
            <!-- 选择企业 -->
            <div v-show="partakeForm.userType === '2'" class="border">
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :default-checked-keys="partakeForm.mechanism"
                :check-strictly="true"
              />
            </div>
            <!-- 选择标签 -->
            <div v-show="partakeForm.userType === '3'" class="border">
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :default-checked-keys="partakeForm.tag"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">成团记录</span>
      </div>
      <STable
        ref="groupDetailTableref"
        :url="url"
        :columns="columns"
        :query="query"
        :selection="false"
        :toolbar="toolbar"
        label-width="100px"
      />
    </el-card>
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
import { numberfilter } from '@/utils/tool'
import { treeDisabled } from '@/utils/tool'
const token = window.localStorage.getItem('token')
export default {
  // props: {
  //   // 通过id查询详情信息
  //   id: {
  //     type: Number,
  //     default: ''
  //   }
  // },
  data() {
    return {
      url: '/activity/pageGroup',
      columns: [
        {
          label: '组团状态',
          prop: 'status',
          template: function(index, record) {
            if (record.status === '1') {
              return '进行中'
            } else if (record.status === '2') {
              return '成功'
            } else if (record.status === '3') {
              return '失败'
            }
          },

        },
        {
          label: '目标完成情况',
          showTip:true,
          prop: 'currentAmount',
          template: function(index, record) {
            return record.currentAmount + '/' + record.targetAmount
          }
        },
        {
          label: '当前/总参团人数',
          prop: 'currentMembers',
          template: function(index, record) {
            return record.currentMembers + '/' + record.targetMembers
          }
        },
        {
          label: '团ID',
          prop: 'id'
        },
        {
          label: '团长账号',
          prop: 'initiatorLoginName'
        },
        {
          label: '团长姓名',
          prop: 'initiatorUserName'
        },
        {
          label: '团员信息',
          prop: 'membersDesc'
        },
        {
          label: '开团时间',
          prop: 'createTime'
        }
      ],
      query: [
        {
          label: '组团状态',
          prop: 'groupStatus',
          placeholder: '请选择组团状态',
          type: 'select',
          data: [{
            label: '进行中',
            value: '1'
          }, {
            label: '成功',
            value: '2'
          }, {
            label: '失败',
            value: '3'
          }]
        }, {
          label: '团长账号',
          prop: 'initiatorLoginName',
          placeholder: '请输入团长账号'
        }, {
          label: '团员账号',
          prop: 'memberLoginName',
          placeholder: '请输入团员账号'
        }, {
          label: '开团时间',
          prop: 'timeRange',
          placeholder: '',
          type: 'date2'
        }
      ],
      toolbar: [
        {
          label: '导出',
          icon: 'el-icon-download',
          type: 'primary',
          handle: (resp) => {
            const url = HOST + '/activity/exportGroup?activityId=' + this.id
            const data = this.$refs.groupDetailTableref.getQueryData()
            $.fileDownload(url, {
              httpMethod: 'GET',
              data: {
                token: window.localStorage.getItem('token'),
                ...data
              },
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出成团记录失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ],
      rewardForm: {
        coupons: [
          {
            couponId: '', // 优惠券id
            count: '' // 优惠券数量
          }
        ]
      },
      rewardForm2: {
        coupons: [
          {
            couponId: '', // 优惠券id
            count: '' // 优惠券数量
          }
        ]
      },
      // 活动奖励表单数据
      // 活动电站
      activitystationType: [
        {
          label: '全部电站',
          id: '1'
        },
        {
          label: '选择运营商',
          id: '2'
        },
        {
          label: '选择电站',
          id: '3'
        }
      ],
      configForm2: {
        stationType: '1', // 活动电站单选框
        operator: [], // 选择运行商时的树数据
        station: [],
        activityGroup: '',
        consumptionDimension: '2', // 消费维度
        amount: ''
      },
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      operatorTreeData: [],
      stationTreeData: [],
      ruleForm: {
        activityName: '', // 活动名称
        activityTime: [], // 活动时间
        activityExplain: '' // 活动说明
      },
      // 所有的优惠券数据
      allCoupon: [],
      // 活动配置表单
      configForm: {
        activityCopywriting: '',
        activityReason: ''
      },
      // 可参与用户字段的单选数据
      userTypeItem: [
        {
          label: '全部用户',
          id: '1'
        },
        {
          label: '选择企业',
          id: '2'
        },
        {
          label: '选择标签',
          id: '3'
        }
      ],
      mechanismTreeData: [], // 企业树的全部数据
      tagTreeData: [], // 标签树的全部数据
      // 可参与用户表单
      partakeForm: {
        userType: '1', // 可参与用户的单选字段
        mechanism: [], // 选择企业
        tag: [] // 选择标签
      }
    }
  },
  computed: {
    headers() {
      return {
        token: token
      }
    },
    action() {
      return HOST + '/oss'
    }
  },
  watch: {},
  beforeMount() {
        this.id=this.$route.query.id
    this.url = '/activity/pageGroup?activityId=' + this.id
  },
  mounted() {
  // 获取全部优惠券数据
    this.loadCoupon()
    // 查询全部企业方法
    this.getMechanismTree()
    // 查询全部标签方法
    this.getTagTree()
    // 查询全部运营商方法
    this.getOperatorTree()
    // 查询全部电站方法
    this.getStationTree()
    this.$nextTick(() => {
      // 获取数据
      this.getData()
    })
  },
  methods: {
    getOperatorTree() {
      const data = {
        treeDepth: 'ORG'
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: data,
        callback: (resp) => {
          this.operatorTreeData = treeDisabled(resp, true)
        }
      })
    },
    // 查询全部电站树的数据
    getStationTree() {
      const data = {
        treeDepth: 'STATION'
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: data,
        callback: (resp) => {
          this.stationTreeData = treeDisabled(resp, true)
        }
      })
    },
    // 查询全部企业树的数据
    getMechanismTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/org',
        data: { orgType: '1,3' },
        callback: (resp) => {
          this.mechanismTreeData = treeDisabled(resp, true)
        }
      })
    },
    numberfilter(num) {
      return numberfilter(num)
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000,
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: (resp) => {
          console.log(resp)
          if (resp.list && resp.list.length > 0) {
            this.allCoupon = resp.list
            this.$forceUpdate()
          }
        }
      })
    },
    // 查询全部标签树的数据
    getTagTree() {
      this.$store.dispatch('form/handle', {
        url: '/user/label/all',
        data: { orgType: '1,3', labelType: '0' },
        callback: (resp) => {
          this.tagTreeData = treeDisabled(resp, true)
        }
      })
    },
    // 查询优惠券库存
    queryCouponStock(id) {
      let val = this.allCoupon.find((item) => {
        return item.couponId === id
      })
      val = val || ''
      return val.stock || 0
    },
    // 页面数据转换方法
    getData() {
      this.$store.dispatch('form/handle', {
        url: '/activity/get',
        data: { id: this.id },
        method: 'get',
        callback: (record) => {
          this.ruleForm = {
            activityName: record.name, // 活动名称
            activityTime: [record.start, record.end], // 活动时间
            activityExplain: record.description // 活动说明
          }
          this.configForm = {
            activityCopywriting: record.img,
            activityReason: record.rule
          }
          this.configForm2 = {
            stationType: record.stationType, // 活动电站单选框
            operator: record.stationType === '2' ? record.stationValue.split(',') : [],
            station: record.stationType === '3' ? record.stationValue.split(',') : [],
            activityGroup: record.minMembers,
            consumptionDimension: record.consumptionType,
            amount: record.coupons[0].amount
          }
          this.partakeForm = {
            userType: record.userType, // 可参与用户的单选字段
            mechanism: record.userType === '2' ? record.userValue.split(',') : [], // 选择企业
            tag: record.userType === '3' ? record.userValue.split(',') : [] // 选择标签
          }
          if (record.coupons && record.coupons[0].coupons) {
            this.rewardForm.coupons = []
            this.rewardForm2.coupons = []
            record.coupons[0].coupons.forEach(item => {
              if (item.targetType === '1') {
                this.rewardForm.coupons.push({
                  couponId: item.couponId, // 优惠券id
                  count: item.count // 优惠券数量
                })
              } else {
                this.rewardForm2.coupons.push({
                  couponId: item.couponId, // 优惠券id
                  count: item.count // 优惠券数量
                })
              }
            })
          }
        }
      })
    },
    back() {
      // this.$emit('backHome')
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less" scoped>
/deep/.el-upload {
  width: 100%;
}
.imgborder {
  display: inline-block;
  width: 100%;
  height: 180px;
  text-align: center;
  line-height: 180px;
  border: 1px dashed #e0e0e0;
  border-radius: 5px;
  i {
    font-size: 28px;
    color: #e0e0e0;
  }
}
.avatar {
  max-height: 200px;
  width: auto;
}
.d-flex {
  display: flex;
}
.flexJCenter {
  display: flex;
  justify-content: center;
}
.mt-25 {
  margin-top: 25px;
}
.currentStock {
  height: 20px;
  align-items: center;
}
.ml-20 {
  margin-left: 20px;
}
.ml-10 {
  margin-left: 10px;
}
.mr-10 {
  margin-right: 10px;
}
.icon-jia {
  font-size: 22px;
  align-items: center;
  display: flex;
}
.border {
  border: 1px solid #eeeeee;
  padding: 20px;
  height: 300px;
  overflow-y: auto;
}

</style>



// WEBPACK FOOTER //
// src/views/activityManagement/groupDetail.vue